/**
 * An item's picture, or a quiet placeholder when there is none or it fails
 * to load. Pictures are square product shots on white.
 */
import { useState } from 'react'
import { Shirt } from 'lucide-react'

import { cn } from '@/lib/utils'

interface ItemPictureProps {
  src: string | null | undefined
  alt: string
  className?: string
}

export function ItemPicture({ src, alt, className }: ItemPictureProps) {
  const [failed, setFailed] = useState(false)
  if (!src || failed) {
    return (
      <div
        className={cn('flex items-center justify-center bg-gray-50 text-gray-300', className)}
        role="img"
        aria-label={alt}
      >
        <Shirt className="h-1/3 w-1/3 max-h-10 max-w-10" />
      </div>
    )
  }
  return (
    <img
      src={src}
      alt={alt}
      loading="lazy"
      decoding="async"
      onError={() => setFailed(true)}
      className={cn('bg-white object-contain', className)}
    />
  )
}
